// extracted by mini-css-extract-plugin
export var container = "_7y-0";
export var fallback = "_7y-5";
export var fallbackIcon = "_7y-6";
export var hidden = "_7y-2";
export var image = "_7y-3";
export var loaded = "_7y-4";
export var placeholder = "_7y-1";